import React, { useState, useEffect } from 'react';

import { Router as ReactRouter, NavigationType } from 'react-router-dom';
import { History as HistoryInterface } from 'history';

interface RouterProps {
  history: HistoryInterface;
  children: React.ReactNode;
}

export const Router = ({ history, children }: RouterProps) => {
  const [, setLocation] = useState(history.location);

  useEffect(() => {
    history.listen(setLocation);
  }, [history]);

  return (
    <ReactRouter
      location={history.location}
      navigator={history}
      navigationType={history.action as NavigationType}
    >
      {children}
    </ReactRouter>
  );
};
